import AdSlot from "../AdSlot";

export default function CategoryInlineAd() {
  return (
    <AdSlot
      slot="2729446592"
      className="my-8"
      style={{ minHeight: "100px" }}
    />
  );
}